/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../../../SmoothScroll";
import MRIVideo from "../../../../assets/images/Service Page/main.mp4";
import ComparisonMRI from "../../../../assets/images/Service Page/MRI Service/MRIMain.jpg";
import OpenBariatricMRI from "../../../../assets/images/Service Page/MRI Service/Medium - 150 DPI-MR_Magnetom_FreeMax_211_IMAGE_20_CMYK.jpg";
import OpenMRI from "../../../../assets/images/Service Page/MRI Service/OpenMRI.png";
import WhyMRI from "../../../../assets/images/Service Page/MRI Service/whyMRI.png";
import ClaustrophobicPatient from "../../../../assets/images/Service Page/MRI Service/Toolkit_MAGNETOM_FreeMax_Physician_SocialMedia_1080x1080.jpg";
import MRIAI from "./MRIAI";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import shape from "../../../../assets/images/home-page/9-01.png";
import { Helmet } from "react-helmet-async";
export default function MRI() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Advanced Open MRI Imaging | Citrus Diagnostics |Crystal River
        </title>
        <meta
          name="description"
          content="What makes MRI different at CDC? Radiologist-designed protocols, advanced imaging technology and AI-enhanced precision without compromising patient comfort."
        />
        <meta
          name="keywords"
          content="Advanced MRI Imaging
open mri & imaging
mri imaging
mri imaging center
advanced diagnostic imaging


"
        />
      </Helmet>
      <div className=" font-robout">
        {/* Hero Section */}
        <div className="relative  px-4 sm:px-8">
          <div className="flex flex-col justify-center items-center xl:px-0 xl:pb-24 xl:pt-36 text-center">
            <h1
              data-aos="fade-right"
              className="font-heading lg:text-[72px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal  capitalize"
            >
              MRI at Citrus Diagnostic Center
            </h1>
            <p
              data-aos="fade-right"
              data-aos-delay="100"
              className=" text-[#cccccc] font-normal "
            >
              Precision without compromise. Comfort without limits.
            </p>
          </div>
        </div>
      </div>
      <div className="relative xl:my-20">
        <img
          src={shape}
          alt=""
          className="
    absolute 
    top-1/2 
    left-1/2 
    -translate-x-1/2 
    -translate-y-1/2 
    pointer-events-none 
    z-0
    opacity-45
  
  "
        />
        <div
          className=" backdrop-blur-[2px]
    xl:bg-[#ffffff13] rounded-xl
      shadow-lg w-full xl:w-[80%] mx-auto py-8 xl:py-16"
        >
          <div className=" text-white font-robout text-center md:max-w-[90%] w-11/12  xl:px-5 py-5 mx-auto ">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize">
                The Flagship of Advanced Imaging
              </h2>
              <p className=" text-[#cccccc] font-normal ">
                MRI is where Citrus Diagnostic Center sets the standard.
              </p>
            </div>
            <p className=" md:max-w-[50%] w-11/12 mx-auto space-y-6">
              Our MRI program is built on{" "}
              <span className="font-extrabold">
                academic-grade technology, radiologist-designed protocols
              </span>
              , and{" "}
              <span className="font-extrabold">AI-enhanced image quality</span>
              -delivering clarity you can trust and an experience designed
              around the patient.
            </p>
          </div>
          <div className="md:max-w-[90%] 3xl:w-[90%] w-11/12 mx-auto xl:py-10 ">
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-24 gap-10  justify-center items-center">
              <div>
                <video
                  src={MRIVideo}
                  autoPlay
                  loop
                  muted
                  playsInline title="Advanced MRI Imaging
"
                  className="w-full h-auto rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
              <div>
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                    Why Our MRI is Different
                  </h2>
                  <p className=" text-[#cccccc] font-normal ">
                    Radiologist-Led from Start to Finish
                  </p>
                </div>
                <p className="">
                  Every MRI protocol at Citrus Diagnostic Center is:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 mt-4">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Designed{" "}
                      <span className="font-extrabold">
                        by board-certified, fellowship-trained radiologists
                      </span>
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Optimized for the clinical question being asked</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Continuously refined using evidence-based standards
                    </span>
                  </li>
                </ul>
                <p className="py-2">
                  This is MRI guided by physicians-not templates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
      >
        <div className="md:max-w-[90%] 3xl:max-w-[90%] w-11/12 mx-auto xl:py-24 py-10 ">
          <div className="py-8 xl:py-14 px-5 bg-[#0f0f0f] rounded-xl ">
            <h2 className="lg:text-[52px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  text-center pb-5">
              Research-Grade Siemens MRI Technology
            </h2>
            <p className=" text-center w-full xl:w-[70%] 3xl:w-[35%] mx-auto">
              We utilize{" "}
              <span className="font-extrabold ">
                Siemens MRI platforms used in leading universities and academic
                medical centers,
              </span>{" "}
              including:
            </p>
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-8 xl:p-20  py-8 ">
              <div className="  flex flex-col justify-center items-start px-5 xl:px-0">
                <h3 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize">
                  Wide-Bore High-Field MRI (1.5T)
                </h3>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 mt-4">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      High-resolution imaging for brain, spine, joints, abdomen,
                      and pelvis
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Advanced gradient performance for speed and detail
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Ideal balance of image quality and patient comfort
                    </span>
                  </li>
                </ul>
              </div>
              <div className="flex justify-center items-center ">
                <img
                  src={ComparisonMRI}
                  alt="  Wide-Bore High-Field MRI (1.5T)"
                  className="rounded-3xl"
                />
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-8 xl:px-20  py-8 ">
              <div className="flex justify-center items-center order-2 xl:order-1">
                <img
                  src={OpenBariatricMRI}
                  alt=" Open & Bariatric MRI (80-cm Open-Bore)"
                  className="rounded-3xl"
                />
              </div>
              <div className="flex flex-col justify-center items-start order-1 xl:order-2">
                <h3 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading   ">
                  Open & Bariatric MRI (80-cm Open-Bore)
                </h3>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 mt-4">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      One of the{" "}
                      <span className="font-extrabold">
                        largest MRI openings available worldwide
                      </span>
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      A{" "}
                      <span className="font-extrabold">
                        shorter tunnel design
                      </span>{" "}
                      that reduces claustrophobia
                    </span>
                  </li>

                  {/* Parent item with nested list */}
                  <li className="space-y-2">
                    <div className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Designed for:</span>
                    </div>

                    {/* Nested list */}
                    <ul className="pl-6 space-y-2">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                        <span>Claustrophobic patients</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                        <span>Bariatric patients</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                        <span>Patients with pain or limited mobility</span>
                      </li>
                    </ul>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      AI-assisted reconstruction delivers{" "}
                      <span className="font-extrabold">
                        high-field image quality
                      </span>{" "}
                      comparable to traditional closed MRI systems
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="  text-[#cccccc] flex flex-col xl:flex-row gap-3 justify-center items-center capitalize py-10">
              <p className="xl:text-[32px] text-[20px] "> More space.</p>
              <p className="xl:text-[32px] text-[20px] ">Less stress. </p>
              <p className="xl:text-[32px] text-[20px] text-center ">
                No loss of diagnostic confidence.{" "}
              </p>
            </div>
          </div>
          <div className="py-8 xl:py-14 px-5 bg-[#0f0f0f] rounded-xl mt-10">
            <div className="lg:pb-20 pb-10">
              <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 xl:p-20 py-10 ">
                <div className="bg-[#000] p-8 rounded-xl">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                      Why This Is Different from Traditional “Open MRI”
                    </h2>
                    <p className=" text-[#cccccc] font-normal  ">
                      Not all open MRI systems are the same.
                    </p>
                  </div>
                  <p className=" pb-2">
                    Older open or standing MRI designs often:
                  </p>
                  <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Use very low magnetic strength</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Limit image resolution</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Reduce magnetic uniformity</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Restrict the types of studies that can be performed
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Make subtle findings harder to detect</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Require repeat imaging for clarity</span>
                    </li>
                  </ul>
                </div>
                <div className=" p-8 ">
                  <h2 className="lg:text-[38px] text-[24px] pb-8 leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize">
                    Modern Open-Bore MRI: A Different Approach
                  </h2>
                  <p className="">
                    Our{" "}
                    <span className="font-extrabold">
                      Open & Bariatric MRI (80-cm Open-Bore MRI)
                    </span>{" "}
                    uses a{" "}
                    <span className="font-extrabold">
                      circular, tunnel-based design
                    </span>{" "}
                    that allows the magnetic field to surround the body more
                    evenly-similar to traditional high-quality MRI systems used
                    in hospitals.
                  </p>
                  <p className=" ">
                    When combined with{" "}
                    <span className="font-extrabold">
                      advanced image enhancement technology
                    </span>
                    , this design:
                  </p>
                  <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 mt-4">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Improves image clarity</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Reduces noise and artifacts</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Supports diagnostic-quality imaging for many studies
                      </span>
                    </li>
                  </ul>
                  <p className=" py-2">
                    This approach is{" "}
                    <span className="font-extrabold">
                      fundamentally different
                    </span>{" "}
                    from older open or standing MRI systems.
                  </p>
                </div>
              </div>
              <div className="flex justify-center items-center pb-20">
                <img
                  src={OpenMRI}
                  alt="mri imaging center"
                  className="rounded-3xl"
                />
              </div>
              <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  text-center capitalize">
                Openness alone does not determine MRI quality. Design and
                technology matter.
              </h2>
              <h3 className="flg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal py-10  text-center md:w-[60%] w-11/12 mx-auto">
                Our goal is to provide an MRI experience that feels more open
                without compromising the image quality your diagnosis depends
                on.
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="py-10 xl:py-24 ">
        <div className="md:max-w-[90%] w-11/12 xl:py-28 mx-auto  bg-transparent xl:bg-[#0f0f0f] p-5 xl:p-20  rounded-xl">
          <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10  xl:mb-20 mb-10">
            <div className="   xl:p-8 px-5">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading text-left capitalize">
                Why MRI Environment Matters
              </h2>
              <p className=" mt-8">
                MRI is one of the most sensitive imaging technologies in
                medicine. Image quality depends not only on the scanner itself,
                but also on the{" "}
                <span className="font-extrabold">
                  environment in which it operates
                </span>
                .
              </p>
              <p className="py-2">Permanent MRI suites are:</p>
              <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Purpose-built</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Shielded from external interference</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Environmentally controlled</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Calibrated for consistent performance</span>
                </li>
              </ul>
              <p className=" py-2">
                This allows for{" "}
                <span className="font-extrabold">
                  reliable, high-quality imaging
                </span>
                , especially for complex studies.
              </p>
            </div>
            <div className="bg-[#000] rounded-xl xl:p-8 px-5 ">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading text-left capitalize pb-8">
                Fixed, In-Building MRI for Consistent Diagnostic Quality
              </h2>
              <p className="pb-2">
                MRI performed in a dedicated, in-building suite benefits from:
              </p>
              <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Specialized magnetic and radiofrequency shielding</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Structural stability that minimizes vibration and
                    interference
                  </span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Controlled temperature and power supply</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Consistent system calibration</span>
                </li>
              </ul>
              <p className=" py-2">These factors support:</p>
              <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Clearer images</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Fewer artifacts</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Reduced need for repeat scans</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Greater diagnostic confidence</span>
                </li>
              </ul>
              <p className="py-2">
                At Citrus Diagnostic Center, MRI exams are performed in{" "}
                <span className="font-extrabold">
                  permanent, purpose-built imaging suites
                </span>
                , prioritizing diagnostic reliability.
              </p>
            </div>
          </div>
          <div className="flex justify-center items-center pb-20">
            <img
              src={WhyMRI}
              alt="AI imaging MRI"
              className="rounded-3xl"
            />
          </div>
          <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10">
            <div className=" flex flex-col justify-center items-start px-5 xl:px-0">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  text-left capitalize pb-8">
                Why Image Quality Matters-Especially for Claustrophobic Patients
              </h2>
              <p className=" py-2">
                For patients who are anxious or claustrophobic:
              </p>
              <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Clear, efficient imaging reduces scan time</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    High-quality images reduce the need for repeat exams
                  </span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Accurate diagnosis the first time matters</span>
                </li>
              </ul>
              <p className=" py-2">
                An MRI that feels more open but produces limited images may
                delay diagnosis or require additional testing. Our goal is to
                provide{" "}
                <span className="font-extrabold">comfort with confidence.</span>
              </p>
            </div>
            <div>
              <img
                src={ClaustrophobicPatient}
                alt="ClaustrophobicPatient"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <MRIAI />
      </div>
    </>
  );
}
